import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  createSearchUrlForCustomAPI,
  extractDataFromObject,
  extractNameFromArray,
  GlobalVariables,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../../../actions/utilAction';

export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  createSearchUrlForCustomAPI,
  create_post_data,
  GlobalVariables,
  showErrorMessage,
  showSuccessMessage,
  extractDataFromObject,
  extractNameFromArray,
  API_URL,
  showWarningMessage,
};

export const GET_PAYERS_LIST = `${API_URL}/Payers/GetPayerList`;
export const PAYER_INFO_SAVE = `${API_URL}/Payers/SavePayerData`;
export const GET_PAYER_INFO_BY_ID = `${API_URL}/Payers/GetPayerDataById`;
export const DELETE_PAYER_INFO = `${API_URL}/Payers/DeletePayerData`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_MASTER_STATE_BY_COUNTRYID = `${API_URL}/api/MasterData/GetStateByCountryID`;
export const GET_PAYER_OR_MASTER_SERVICE_CODES = `${API_URL}/api/PayerServiceCodes/PayerOrMasterServiceCodes`;
export const SAVE_PAYER_SERVICE_CODES = `${API_URL}/api/PayerServiceCodes/SavePayerServiceCodes`;
export const SAVE_PAYER_SINGLE_SERVICE_CODE = `${API_URL}/api/PayerServiceCodes/SavePayerServiceCode`;
export const DELETE_PAYER_SERVICE_CODES = `${API_URL}/api/PayerServiceCodes/DeletePayerServiceCodes`;
export const GET_PAYER_SERVICE_CODE_BY_ID = `${API_URL}/api/PayerServiceCodes/GetPayerServiceCodeById`;
export const GET_PAYER_SERVICECODE_MODIFIER_DEPENDENCY = `${API_URL}/api/PayerServiceCodes/CheckPayerServiceCodeModifierDependency`;
export const GET_ALL_PAYER_SERVICE_CODES = `${API_URL}/api/PayerServiceCodes/GetMasterServiceCodeEx`;
export const GET_MASTERSERVICECODE_BYID = `${API_URL}/api/MasterServiceCodes/GetMasterServiceCodeById`;
export const GET_ACTIVITY_LIST = `${API_URL}/PayersActivity/GetActivities`;
export const MASTER_ACTIVITY_FOR_PAYER = `${API_URL}/PayersActivity/GetMasterActivitiesForPayer`;
export const GET_PAYER_ACTIVITY_SERVICE_CODES = `${API_URL}/PayersActivity/GetPayerActivityServiceCodes`;
export const EXCLUDED_SERVICE_CODES = `${API_URL}/PayersActivity/GetExcludedServiceCodesFromActivity`;
export const GET_PAYER_SERVICECODE_BY_ID = `${API_URL}/api/PayerServiceCodes/GetPayerServiceCodeById`;
export const DELETE_PAYER_ACTIVITY_CODE = `${API_URL}/PayersActivity/DeletePayerActivityCode`;
export const GET_ACTIVITY_SERVICE_CODE_BY_ID = `${API_URL}/PayersActivity/GetPayerActivityServiceCodeDetailsById`;
export const UPDATE_ACTIVITY_SERVICE_CODE_MODIFIER = `${API_URL}/PayersActivity/UpdatePayerActivityModifiers`;
export const SAVE_NEW_SERVICE_CODE_IN_ACTIVITY = `${API_URL}/PayersActivity/SavePayerActivityCode`;
export const PAYERACTIVITY_STATUS_ACTIVATION = `${API_URL}/PayersActivity/UpdatePayerActivityStatus`;
export const POST_COPY_PAYERDATA = `${API_URL}/Payers/CopyPayerData`;

export const payerActionTypes = {
  post_payer_info: createRequestActionTypes('PAYER_INFO_SAVE'),
  get_payers_list: createRequestActionTypes('GET_PAYERS_LIST'),
  get_payer_info_by_id: createRequestActionTypes('GET_PAYER_INFO_BY_ID'),
  delete_payer_info: createRequestActionTypes('DELETE_PAYER_INFO'),
  get_master_data: createRequestActionTypes('GET_MASTERDATABYNAME'),
  get_master_state_by_countryid: createRequestActionTypes('GET_MASTER_STATE_BY_COUNTRYID'),
  get_payer_or_master_service_codes: createRequestActionTypes('GET_PAYER_OR_MASTER_SERVICE_CODES'),
  reset_ServiceCodeDetails: createRequestActionTypes('RESET_SERVICECODEDETAILS'),
  save_payer_service_codes: createRequestActionTypes('SAVE_PAYER_SERVICE_CODES'),
  delete_payer_service_code: createRequestActionTypes('DELETE_PAYER_SERVICE_CODES'),
  get_payer_service_code_by_id: createRequestActionTypes('GET_PAYER_SERVICE_CODE_BY_ID'),
  get_payer_servicecode_modifier_dependency: createRequestActionTypes('GET_PAYER_SERVICECODE_MODIFIER_DEPENDENCY'),
  get_all_payer_cpt_codes_by_payer: createRequestActionTypes('GET_ALL_PAYER_CPT_CODE_BY_PAYER'),
  get_masterservicecode_by_Id: createRequestActionTypes('GET_MASTERSERVICECODE_BYID'),
  get_payer_activity: createRequestActionTypes('GET_ACTIVITY_LIST'),
  get_master_activity_for_payer: createRequestActionTypes('MASTER_ACTIVITY_FOR_PAYER'),
  get_payer_activity_service_codes: createRequestActionTypes('GET_PAYER_ACTIVITY_SERVICE_CODES'),
  get_new_payer_service_codes_by_id: createRequestActionTypes('GET_NEW_PAYER_SERVICE_CODES_BY_ID'),
  update_activity_service_code_modifier: createRequestActionTypes('UPDATE_ACTIVITY_SERVICE_CODE_MODIFIER'),
  get_activity_service_code_by_id: createRequestActionTypes('GET_ACTIVITY_SERVICE_CODE_BY_ID'),
  save_new_service_code_in_activity: createRequestActionTypes('SAVE_NEW_SERVICE_CODE_IN_ACTIVITY'),
  delete_payer_activity_code: createRequestActionTypes('DELETE_PAYER_ACTIVITY_CODE'),
  excluded_service_codes: createRequestActionTypes('EXCLUDED_SERVICE_CODES'),
  get_payer_servicecode_by_Id: createRequestActionTypes('GET_PAYER_SERVICECODE_BY_ID'),
  save_single_payer_service_code: createRequestActionTypes('SAVE_PAYER_SINGLE_SERVICE_CODE'),
  patch_payeractivity_active_status: createRequestActionTypes('PATCH_PAYERACTIVITY_ACTIVE_STATUS'),
  post_copy_payer_data: createRequestActionTypes('POST_COPY_PAYERDATA'),
};

export const MODULE = 'PAYER_INFORMATION';





// WEBPACK FOOTER //
// ./src/modules/Payers/constants/ApiConstants.js